import { AppTreeSide, UniDateRangePicker, LineChart } from 'components'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree, loadDataNodeTreeItems} from '@/utils/tree'
import {getOneWeekBeginAndEndDate} from '@/utils/date'

export default {
  name: 'BusinessData',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      // 树节点已加载的区域id数组
      treeNodeLoadedRegionIds: [],
      checkedTreeData: [],
      checkedKeys: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 记录页面--------------------------------------------------------------------------------------------------
      // 表格数据
      dataTableData: [],
      dataTableTotalRow: 0,
      // 图表数据
      dataLineChartId: 'data-line-chart',
      dataLineChartData: [['', '数据节点数值']], // xAxis-时间，yAxis-数据节点数值
      dataLineChartColor: ['#4CA2EB'],
      // 表格查询条件
      dataDates: [], // 查询起始和结束日期
      dataTableQueryParams: {
        regionId: -1,
        objectIds: [],
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        systemKind: 0,
        alarmStates: [],
        beginReportDateTime: 0,
        endReportDateTime: 0,
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      dataTableSelectedIds: [],
      // 事件表格当前行
      dataTableCurrentRow: null,
      // 事件信息弹窗
      showDataModalOpen: false,
      // 轮巡定时器
      pollingTimer: null
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker,
    LineChart
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }
  },
  mounted () {
    // 设置查询起始日期和截止日期
    this.dataDates = getOneWeekBeginAndEndDate() // 近一周

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 查询顶层区域下的数据节点列表
            this.getDataNodeList(this.treeData[0].id)
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 查询数据节点列表
    getDataNodeList(regionId) {
      // 检测该区域下数据节点是否已加载，防止重复加载
      if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
        return
      }

      this.$http(this.$api.dataNodeList, {
        regionId: regionId,
        resourceKind: 23, // 模拟量输入
        pageNum: 1,
        pageSize: 1000
      }).then(
        res => {
          if (res.code === 200) {
            // 检测该区域下数据节点是否已加载，防止重复加载
            if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
              return
            }
            if (res.data.length) {
              this.treeData = loadDataNodeTreeItems(res.data, this.treeData)
              if (this.$refs.tree.getCurrentKey() && this.treeExpandedKeys.indexOf(this.$refs.tree.getCurrentKey()) === -1) {
                this.treeExpandedKeys = []
                this.treeExpandedKeys.push(this.$refs.tree.getCurrentKey()) // 展开父区域
              }
            }
            this.treeNodeLoadedRegionIds.push(regionId)
          }
        }).catch(err => {
        console.log(err)
      })
    },
    // 查询数据列表
    getHistoryDataList() {
      this.loading = true
      this.dataTableQueryParams.beginReportDateTime = this.dataDates[0].getTime() / 1000
      this.dataTableQueryParams.endReportDateTime = this.dataDates[1].getTime() / 1000
      this.dataTableQueryParams.objectIds = []
      if (this.checkedTreeData.length > 0) {
        this.dataTableQueryParams.objectIds = this.checkedTreeData.map(item => item.id)
      }
      this.$http(this.$api.historyDataList, this.dataTableQueryParams).then(
        res => {
          if (res.code === 200) {
            // 表格数据
            this.dataTableData = res.data
            this.dataTableTotalRow = res.page.totalRow

            // 图表数据
            // 绘制line
            this.dataLineChartData = []
            if (res.data.length) {
              // 汇总数据节点
              let dataNodes = []
              if (this.checkedTreeData.length > 0 &&
                this.checkedTreeData.length <= 20) {
                dataNodes = this.checkedTreeData
              } else {
                res.data.forEach(item => {
                  if (dataNodes.indexOf(item.resourceId) === -1) {
                    let dataNode = {id: item.resourceId, name: item.resourceName}
                    dataNodes.push(dataNode)
                  }
                })
              }

              let maxValueCount = 0
              let dataNodeValuess = []
              this.dataLineChartData.push([])
              for (let i = 0; i < dataNodes.length; ++i) { // 遍历节点，汇总数值
                let dataNode = dataNodes[i]
                let chartLengend = dataNode.name
                if (dataNode.dataUnit) {
                  chartLengend += '(' + dataNode.dataUnit + ')'
                }
                this.dataLineChartData[0].push('')
                this.dataLineChartData[0].push(chartLengend)

                let dataNodeValues = []
                for (let j = 0; j < res.data.length; ++j) { // 汇总单个数据节点的数值
                  if (dataNode.id === res.data[j].resourceId) {
                    dataNodeValues.push(new Date(res.data[j].reportTime * 1000))
                    dataNodeValues.push(res.data[j].latestValue)
                  }
                }
                if (maxValueCount < dataNodeValues.length / 2) {
                  maxValueCount = dataNodeValues.length / 2
                }
                dataNodeValuess.push(dataNodeValues)
              }

              let yItem = []
              for (let i = 0; i < maxValueCount; ++i) { // 遍历节点，绘制图表
                yItem = []
                for (let j = 0; j < dataNodeValuess.length; ++j) {
                  if (dataNodeValuess[j].length > i * 2) {
                    yItem.push(new Date(dataNodeValuess[j][i * 2]))
                    yItem.push(dataNodeValuess[j][i * 2 + 1])
                  } else {
                    yItem.push(new Date(dataNodeValuess[j][dataNodeValuess[j].length - 2]))
                    yItem.push(dataNodeValuess[j][dataNodeValuess[j].length - 1])
                  }
                }
                this.dataLineChartData.push(yItem)
              }
            }
            this.$nextTick(() => {
              if (this.$refs.dataLineChart) {
                this.$refs.dataLineChart.draw()
              }
            })
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (!obj) {
        return
      }

      if (this.activeTabName === '0') {
        if (obj.type === 'region') {
          if (this.dataTableQueryParams.regionId !== obj.id) {
            this.getDataNodeList(obj.id)
          }
        } else if (obj.type === 'dataNode') {
        }
      }
    },
    // 勾选树节点
    handleTreeNodeCheck (nodeObj, e) {
      this.checkedTreeData = []
      e.checkedNodes.forEach(item => {
        if (item.type === 'dataNode') {
          this.checkedTreeData.push(item)
        }
      })
      this.checkedKeys = e.checkedKeys
    },
    // tab页面切换
    handleTabClick(tab) {
      let currentNode = this.$refs.tree.getCurrentNode()
      if (currentNode) {
        this.handleTreeNodeClick(currentNode)
      }
    },
    // 事件记录页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleDataFormQuery() {
      this.dataTableQueryParams.page = 1
      this.getHistoryDataList()
    },
    // 重置按钮操作
    resetDataQueryForm() {
      this.dataTableQueryParams.regionId = 0
      this.dataTableQueryParams.objectId = 0
      this.dataTableQueryParams.descendantRegionRequired = 1
      this.dataTableQueryParams.resourceKind = 255
      this.dataTableQueryParams.resourceSubType = 255
      this.dataTableQueryParams.alarmStates = []
      this.dataDates = getOneWeekBeginAndEndDate() // 近一周
      this.dataTableQueryParams.beginReportDateTime = 0
      this.dataTableQueryParams.endReportDateTime = 0
      this.dataTableQueryParams.pageNum = 1
      this.$refs['dataQueryForm'].resetFields()
      this.handleDataFormQuery()
    },
    // 分页
    handleDataCurrentPageChange(val) {
      this.dataTableQueryParams.pageNum = val
      this.getHistoryDataList()
    },
    // 页面条数改变
    handleDataPageSizeChange(val) {
      this.dataTableQueryParams.pageSize = val
      this.getHistoryDataList()
    },
    // 表格选中记录改变
    handleDataTableSelectionChange(selection) {
      this.dataTableSelectedIds = selection.map(item => item.id)
    },
    // 查看事件
    handleDataView(row) {
      if (row && row.id) {
        this.$refs.dataTable.setCurrentRow(row) // 选中当前行
        this.showDataModalOpen = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/events/BusinessData/BusinessData.js